import { optionSubcategory_attachments } from './attachmentsSubCategory.locstring.json';
import AttachmentPreferencesOption from 'owa-attachment-preferences-option/lib/AttachmentPreferencesOption';
import StorageAccountsOption from 'owa-provider-accounts-option/lib/StorageAccountsOption';
import { OptionSubCategory } from 'owa-options-core';

let attachmentsSubCategory: OptionSubCategory = {
    key: 'attachments',
    titleStringKey: optionSubcategory_attachments,
    options: [AttachmentPreferencesOption, StorageAccountsOption],
};

export default attachmentsSubCategory;
